import { QuestShortDetailsBackend } from 'src/store/availableQuests';



import { ApiService, ApiServiceGetResponse } from '@services';
import { MainInventoryBackendCard, QuestCollectStarBackend, QuestDetailsBackend, QuestDialog, QuestId, QuestSubmitBackend } from '@store';
import { getCustomStageQuest } from '@utils';


export interface TapTapBurnedResponse {
  sum_rating_gained: number
  taps_burned: number
  threshold: number
}

interface TapTapBurnResponse {
  prize_item: MainInventoryBackendCard
  thresholds_reached: number
}

export const getQuestsApi = async (): Promise<
  ApiServiceGetResponse<QuestShortDetailsBackend[]>
> => {
  const { ok, data } = await ApiService.get({
    endpoint: '/api/v1/quests',
  })

  return { ok, data: data || null }
}

export const getQuestDetailsApi = async (
  questId: string
): Promise<ApiServiceGetResponse<QuestDetailsBackend>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/quests/${questId}`,
  })

  return { ok, data: data || null }
}

export const collectStarApi = async (
  questId: string,
  partId: number,
  rewardId: number
): Promise<ApiServiceGetResponse<QuestCollectStarBackend>> => {
  let partIdToUse = partId

  const customPartId = getCustomStageQuest[questId as QuestId]?.api?.(partId)
  if (customPartId !== undefined) {
    partIdToUse = customPartId
  }

  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/quests/${questId}/${partIdToUse}/star/${rewardId}`,
  })

  return { ok, data: data || null }
}

export const submitQuestApi = async (
  solution: string,
  questId: string,
  partId: number
): Promise<ApiServiceGetResponse<QuestSubmitBackend>> => {
  let partIdToUse = partId

  const customPartId = getCustomStageQuest[questId as QuestId]?.api?.(partId)
  if (customPartId !== undefined) {
    partIdToUse = customPartId
  }

  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/quests/${questId}/${partIdToUse}/submit`,
    formData: solution,
  })

  return { ok, data: data || null }
}

export const fetchQuestDialogApi = async (
  questSlug: QuestId
): Promise<ApiServiceGetResponse<QuestDialog>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/quests/${questSlug}/dialog`,
  })

  return { ok, data: data || null }
}

export const answerQuestDialogApi = async (
  questSlug: QuestId,
  answerId: string
): Promise<ApiServiceGetResponse<QuestDialog>> => {
  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/quests/${questSlug}/dialog`,
    data: {
      choice_id: answerId,
    },
  })

  return { ok, data: data || null }
}

export const burnTapsApi = async (
  amount: number,
  signal?: AbortSignal
): Promise<ApiServiceGetResponse<TapTapBurnResponse>> => {
  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/bank/taps/burn`,
    data: {
      amount,
    },
    options: {
      signal,
    },
  })
  return { ok, data: data || null }
}

export const getTapTapBurnedApi = async (
  signal?: AbortSignal
): Promise<ApiServiceGetResponse<TapTapBurnedResponse>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/bank/taps/burned`,
    signal,
  })

  return { ok, data: data || null }
}
